"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DateTime_1 = require("./DateTime");
exports.default = DateTime_1.default;
exports.FormDateTime = DateTime_1.FormDateTime;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/components/controls/DateTime/index.js
// module id = 961
// module chunks = 0